export default __webpack_public_path__ + "static/artifakt-element-italic-07da3e1c8f69e3a7a22d9991d1b6b2f4.ttf";